import React, { useMemo, useEffect } from "react";
import { getUserScreens } from "../../store/reducer/screen/screenSlice";
import { Link, useLocation, useParams } from "react-router-dom";
import { getDdOptionForUI } from "../../store/reducer/ddOption/ddOptionSlice";
import { useSelector, useDispatch } from "react-redux";

const DrawingTabs = () => {
  const { id, drawing_id } = useParams();
  const location = useLocation();

  const dispatch = useDispatch();
  
    // 1. Get Data from Redux
    const userScreens = useSelector((state) => state.screens.screens || []);
    const { options } = useSelector((state) => state.ddOptions);

    // 2. Fetch data if it's missing (Handling the "empty" state)
    useEffect(() => {
        const userSession = JSON.parse(localStorage.getItem("userSession"));
        
        if (userSession?.id) {
        if (!userScreens || userScreens.length === 0) {
            dispatch(getUserScreens(userSession.id));
        }
        if (!options || options.length === 0) {
            dispatch(getDdOptionForUI());
        }
        }
    }, [dispatch, userScreens.length, options.length]);

  // Define all tabs and their required permission codes
  const tabs = useMemo(() => [
    { name: "Drawing Detail", path: `/opportunity/${id}/drawing/${drawing_id}`, code: "DRAWING_EDIT" },
    { name: "Site Detail", path: `/opportunity/${id}/drawing/${drawing_id}/site`, code: "DRAWING_SITE_EDIT" },
    { name: "Take Off", path: `/opportunity/${id}/drawing/${drawing_id}/take-off`, code: "DRAWING_TAKEOFF_EDIT" },
    { name: "BOM", path: `/opportunity/${id}/drawing/${drawing_id}/bom`, code: "DRAWING_BOM_EDIT" },
    { name: "Install", path: `/opportunity/${id}/drawing/${drawing_id}/install`, code: "DRAWING_INSTALL_EDIT" },
    { name: "Additional Options", path: `/opportunity/${id}/drawing/${drawing_id}/additional-options`, code: "DRAWING_OPTIONS_EDIT" },
    { name: "Questions", path: `/opportunity/${id}/drawing/${drawing_id}/questions`, code: "DRAWING_QUESTIONS_VIEW" },
    { name: "Discount", path: `/opportunity/${id}/drawing/${drawing_id}/discount`, code: "DRAWING_DISCOUNT_EDIT" },
    { name: "P&L", path: `/opportunity/${id}/drawing/${drawing_id}/pandl`, code: "DRAWING_PL_VIEW" },
    { name: "Proposal", path: `/opportunity/${id}/drawing/${drawing_id}/proposal`, code: "DRAWING_PROPOSAL_EDIT" },
    { name: "Files", path: `/opportunity/${id}/drawing/${drawing_id}/files`, code: "DRAWING_FILES_EDIT" },
    { name: "Create PO", path: `/opportunity/${id}/drawing/${drawing_id}/purchase-orders`, code: "DRAWING_PO_VIEW" },
    { name: "PO History", path: `/opportunity/${id}/drawing/${drawing_id}/purchase-orders/history`, code: "DRAWING_PO_HISTORY" },
    { name: "Commercial Invoice", path: `/opportunity/${id}/drawing/${drawing_id}/commercial-invoice`, code: "DRAWING_INVOICE_VIEW" },
    { name: "Snags", path: `/opportunity/${id}/drawing/${drawing_id}/expense-snags`, code: "DRAWING_SNAGS_ADD" },
  ], [id, drawing_id]);

  // Filter the tabs based on the user's permissions
  const allowedTabs = tabs.filter(tab => {
    if (!options || options.length === 0 || !userScreens || userScreens.length === 0) {
      return false; 
    }
    const targetOption = options.find(
      (opt) => opt.field_value === tab.code && opt.ui_name === "Screens"
    );

    return targetOption && userScreens.includes(targetOption.id);
  });

  return (
    <div className="flex gap-[30px] bg-[#61b35436] p-2 rounded-lg mb-10 overflow-auto text-nowrap justify-between">
      {allowedTabs.map((tab) => (
        <Link key={tab.path} to={tab.path}>
          <div
            className={`font-Inter text-[16px] font-[400] px-5 py-2 rounded-lg ${
              location.pathname === tab.path
                ? "text-white bg-[#55A14A]"
                : "text-black hover:bg-[#55A14A] hover:text-white"
            }`}
          >
            {tab.name}
          </div>
        </Link>
      ))}
    </div>
  );
};

export default DrawingTabs;